var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.component)?_c(_vm.component,{tag:"component",class:_vm.iconClass}):_c('span',{class:_vm.iconClass})
}
var staticRenderFns = []

export { render, staticRenderFns }